import { forwardRef } from 'react';

import { ActionIcon, cx } from 'ui';
import { IconMore } from 'ui/Icons';

import { ACTION_MENU_TARGET_ID } from '../../../config/constants';
import classes from './RowActionTarget.module.css';

const RowActionTarget = forwardRef<HTMLButtonElement, { loading: boolean }>(
  ({ loading, ...rest }, ref) => {
    return (
      <ActionIcon
        variant="subtle"
        bg="white"
        radius="xl"
        color="cobalt"
        size="sm"
        {...rest}
        loading={loading}
        ref={ref}
        className={cx(classes.RowActionTarget, ACTION_MENU_TARGET_ID)}
      >
        <IconMore />
      </ActionIcon>
    );
  }
);

RowActionTarget.displayName = 'RowActionTarget';

export { RowActionTarget };
